export enum PublicResultType {
    MailHasBeenSent = 0,
    NewMemberHasBeenRegisted = 1,
    NewMemberHasActivatedAccount = 2,
    DetailsHasBeenSaved = 3
}